// Headless export registration for Van Keulen / Westendorp (multi-output).
// The live vk Block is reused as-is. DefaultView renders one chart; InfographicView
// renders up to 4 (Westendorp, purchase-probability, purchase-frequency, profit/
// revenue) — each tagged data-capture-index, rasterized to a PNG array.
// Keys `vk` and `wd` are the legacy pptx.coffee dispatch keys (Option A).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/05-vk.md §4.2

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import Block from '@aytm/app/stats/page/question-views/vk/Block'

const vkEntry: ExportableChart = {
  Component: Block,
  toProps: (data: any, params: any) => ({
    sectionKey: data.sectionKey,
    id: data.id,
    type: data.type,
    components: data.components,
    palette: data.palette,
    globalChartMode: params.chartMode,
    period: params.period,
    fqPeriod: data.fqPeriod,
    text: data.text,
    // infographic=true drives the multi-chart view; default single DefaultView.
    infographic: params.infographic ?? false,
    answer: data.answer,
    config: data.config,
    reportParams: data.reportParams,
    // Interactive callbacks stay undefined in headless.
    navTo: undefined,
    isAnimated: false,
    isLoading: false,
    onModelChange: undefined,
    onExport: undefined,
    onReset: undefined
  })
}

// Both keys map to the same Block; the active sub-mode is config/answer-driven.
ExportableCharts.register('vk', vkEntry)
ExportableCharts.register('wd', vkEntry)
